export default __webpack_public_path__ + "static/media/hands-up.84daf13b.png";